import { useState } from "react"; // 1. Import useState
import { Container, Row, Col } from "react-bootstrap";
import logo from "../assets/img/my-logo-wb.png";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon3 from "../assets/img/email.png"; 
import git from "../assets/img/gitt.png";

export const Footer = () => {
  // 2. State to handle the "Copied!" message
  const [copied, setCopied] = useState(false);

  const handleCopy = (e) => {
    e.preventDefault(); // Prevent opening email app
    navigator.clipboard.writeText("zeeshanachra1@gmail.com"); // Copy to clipboard
    setCopied(true); // Show message
    
    // Hide message after 2 seconds
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          
          {/* 1. Left Part: Logo */}
          <Col size={12} sm={4} className="text-center text-sm-start">
            <img src={logo} alt="Logo" />
          </Col>

          {/* 2. Middle Part: Privacy Policy */}
          <Col size={12} sm={4} className="text-center">
            <div className="privacy-link" style={{ marginBottom: "10px" }}>
              <a href="#privacy" style={{ textDecoration: "none", color: "white", fontWeight: "bold" }}>
                Privacy Policy
              </a>
            </div>
            <p>Copyright 2021. All Rights Reserved</p>
          </Col>

          {/* 3. Right Part: Social Icons */}
          <Col size={12} sm={4} className="text-center text-sm-end">
            <div className="social-icon">
              <a
                href="https://www.linkedin.com/in/zees-ali/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={navIcon1} alt="LinkedIn" />
              </a>
              <a href="https://github.com/zeshantech" target="_blank" rel="noreferrer">
                <img src={git} alt="GitHub" />
              </a>

              {/* 3. Email Icon with Copy Functionality */}
              <div style={{ position: "relative", display: "inline-block" }}>
                <a href="zeeshanachra1@gmail.com" onClick={handleCopy}>
                  <img src={navIcon3} alt="Email" />
                </a>
                
                {/* The "Copied!" Tooltip */}
                {copied && (
                  <div style={{
                    position: "absolute",
                    top: "-40px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    backgroundColor: "#28a745", // Green background
                    color: "white",
                    padding: "5px 10px",
                    borderRadius: "5px",
                    fontSize: "12px",
                    fontWeight: "bold",
                    whiteSpace: "nowrap",
                    boxShadow: "0px 2px 10px rgba(0,0,0,0.2)",
                    zIndex: 10
                  }}>
                    Copied!
                    {/* Tiny arrow pointing down */}
                    <div style={{
                        position: "absolute",
                        top: "100%",
                        left: "50%",
                        transform: "translateX(-50%)",
                        borderWidth: "5px",
                        borderStyle: "solid",
                        borderColor: "#28a745 transparent transparent transparent"
                    }}></div>
                  </div>
                )}
              </div>

            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};